import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import printService from '../services/print.service'
import billOfLadingApi, {
  BillOfLadingUpdateRequest
} from '../apis/billOfLading.api'
import { ShipOrderData } from '../apis/shipOrder.api'
import { ItemData } from '../apis/item.api'
import dateUtil from '../utils/date.util'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import BillOfLadingGenerateForm from '../partials/BillOfLadingGenerateForm'
import ContentAside from '../components/ContentAside'
import BillOfLadingGenerateCustomer from '../partials/BillOfLadingGenerateCustomer'
import Signature from '../components/Signature'

interface BillOfLadingGenerateRouteState {
  id: number
}

interface BillOfLadingGenerateProps
  extends RouteComponentProps<any, any, BillOfLadingGenerateRouteState> {}

interface BillOfLadingGenerateState {
  loadStartAt: string
  departureAt: string
  trailerNumber: string
  sealNumber: string
  driverCheckInAt: string
  supervisorName: string
  supervisorSignature: string
  driverName: string
  carrier: string
  note: string
  driverSignature: string
  shipOrder: ShipOrderData | null
  items: ItemData[]
}

class BillOfLadingGenerate
  extends Component<BillOfLadingGenerateProps, BillOfLadingGenerateState> {
  constructor (props: BillOfLadingGenerateProps) {
    super(props)
    const date = dateUtil.now()
    this.state = {
      loadStartAt: date,
      departureAt: date,
      trailerNumber: '',
      sealNumber: '',
      driverCheckInAt: date,
      supervisorName: '',
      supervisorSignature: '',
      driverName: '',
      carrier: '',
      note: '',
      driverSignature: '',
      shipOrder: null,
      items: []
    }
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSignatureChange = this.handleSignatureChange.bind(this)
    this.handleGenerateClick = this.handleGenerateClick.bind(this)
  }

  get id () {
    return this.props.location.state.id
  }

  get customer () {
    const { shipOrder } = this.state
    if (
      !shipOrder ||
      !shipOrder.customerSite ||
      !shipOrder.customerSite.address ||
      !shipOrder.customerSite.contact ||
      !shipOrder.customerSite.contact.customer
    ) return
    const customer = shipOrder.customerSite.contact.customer
    const address = shipOrder.customerSite.address
    return shipOrder &&
      <BillOfLadingGenerateCustomer
        shipOrder={shipOrder.code}
        name={customer.name}
        address={address.address}
        city={address.city}
        state={address.state}
        zip={address.zip} />
  }

  handleDateChange (name: string, date: string) {
    if (name === 'loadStartAt') this.setState({ loadStartAt: date })
    else if (name === 'departureAt') this.setState({ departureAt: date })
    else if (name === 'driverCheckInAt') this.setState({ driverCheckInAt: date })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'trailerNumber') this.setState({ trailerNumber: value })
    else if (name === 'sealNumber') this.setState({ sealNumber: value })
    else if (name === 'supervisorName') this.setState({ supervisorName: value })
    else if (name === 'driverName') this.setState({ driverName: value })
    else if (name === 'carrier') this.setState({ carrier: value })
    else if (name === 'note') this.setState({ note: value })
  }

  handleSignatureChange (name: string, signature: string) {
    if (name === 'supervisorSignature') {
      this.setState({ supervisorSignature: signature })
    } else if (name === 'driverSignature') {
      this.setState({ driverSignature: signature })
    }
  }

  generateBillOfLading () {
    billOfLadingApi.generate(this.id, billOfLading => {
      if (!billOfLading) return
      printService.print(billOfLading)
    })
  }

  handleGenerateClick () {
    const payload: BillOfLadingUpdateRequest = {}
    const { loadStartAt, departureAt, trailerNumber } = this.state
    const { sealNumber, driverCheckInAt, supervisorName } = this.state
    const { driverName, carrier, note } = this.state
    const { driverSignature, supervisorSignature } = this.state
    if (loadStartAt) payload.loadStartTime = loadStartAt
    if (departureAt) payload.departureTime = departureAt
    if (trailerNumber) payload.trailerNumber = trailerNumber
    if (sealNumber) payload.sealNumber = sealNumber
    if (carrier) payload.carrier = carrier
    if (note) payload.note = note
    if (driverCheckInAt) payload.driverCheckIn = driverCheckInAt
    if (supervisorName) payload.supervisorName = supervisorName
    if (driverName) payload.driverName = driverName
    if (supervisorSignature) payload.supervisorSignature = supervisorSignature
    if (driverSignature) payload.driverSignature = driverSignature
    billOfLadingApi.update(this.id, payload, billOfLading => {
      if (!billOfLading) return
      this.generateBillOfLading()
    })
  }

  readBillOfLading () {
    billOfLadingApi.read(this.id, billOfLading => {
      if (!billOfLading) return
      const { loadStartAt, departureAt, trailerNumber } = billOfLading
      const { sealNumber, driverCheckInAt, supervisorName } = billOfLading
      const { driverName, carrier, note, shipOrder } = billOfLading
      if (loadStartAt) this.setState({ loadStartAt })
      if (departureAt) this.setState({ departureAt })
      if (trailerNumber) this.setState({ trailerNumber })
      if (sealNumber) this.setState({ sealNumber })
      if (driverCheckInAt) this.setState({ driverCheckInAt })
      if (supervisorName) this.setState({ supervisorName })
      if (driverName) this.setState({ driverName })
      if (carrier) this.setState({ carrier })
      if (note) this.setState({ note })
      if (shipOrder) this.setState({ shipOrder })
      if (shipOrder && shipOrder.items) {
        this.setState({ items: shipOrder.items })
      }
    })
  }

  componentDidMount () {
    this.readBillOfLading()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <BillOfLadingGenerateForm
            loadStartAt={this.state.loadStartAt}
            departureAt={this.state.departureAt}
            trailerNumber={this.state.trailerNumber}
            sealNumber={this.state.sealNumber}
            driverCheckInAt={this.state.driverCheckInAt}
            supervisorName={this.state.supervisorName}
            driverName={this.state.driverName}
            carrier={this.state.carrier}
            note={this.state.note}
            items={this.state.items}
            onDateChange={this.handleDateChange}
            onInputChange={this.handleInputChange}
            onGenerateClick={this.handleGenerateClick} />
        </ContentMain>
        <ContentAside layout="oneThird">
          <div className="flex flex-col gap-5">
            {this.customer}
            <Signature
              name="supervisorSignature"
              label="Ship Supervisor Signature"
              onChange={this.handleSignatureChange} />
            <Signature
              name="driverSignature"
              label="Driver Signature"
              onChange={this.handleSignatureChange} />
          </div>
        </ContentAside>
      </ContentLayout>
    )
  }
}

export default withRouter(BillOfLadingGenerate)
